'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Credential(id, kind, name, username, hash, inherited, created, expires) {
  this.n4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.i8 = null;
  this.fB = null;
  this.kk = null;
  this.eE = null;
  this.Lh = false;
  this.E0 = null;
  this.xr = null;
  this.n4 = id;
  this.i8 = kind;
  this.fB = name;
  this.kk = username;
  this.eE = hash;
  this.Lh = inherited;
  this.E0 = created;
  this.xr = expires;
}
export { $c_Lpresto_types$Credential as $c_Lpresto_types$Credential };
$p = $c_Lpresto_types$Credential.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Credential;
/** @constructor */
function $h_Lpresto_types$Credential() {
}
export { $h_Lpresto_types$Credential as $h_Lpresto_types$Credential };
$h_Lpresto_types$Credential.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("Credential"));
  var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$();
  var $x_1 = acc;
  var t = this.n4;
  acc = $x_2.o($x_1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().bj(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t.e, t.f)));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.i8));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.fB));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.kk));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.eE));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.Lh ? 1231 : 1237));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.E0));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.xr));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 8);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$Credential)) {
    if ((this.Lh === x$0.Lh)) {
      var this$1 = this.n4;
      var b = x$0.n4;
      var $x_3 = ((this$1.e === b.e) && (this$1.f === b.f));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x = this.i8;
      var x$2 = x$0.i8;
      var $x_2 = (x === x$2);
    } else {
      var $x_2 = false;
    }
    if (((($x_2 && (this.fB === x$0.fB)) && (this.kk === x$0.kk)) && (this.eE === x$0.eE))) {
      var x$3 = this.E0;
      var x$4 = x$0.E0;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.xr;
      var x$6 = x$0.xr;
      return ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 8;
});
$p.s = (function() {
  return "Credential";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.n4;
      break;
    }
    case 1: {
      return this.i8;
      break;
    }
    case 2: {
      return this.fB;
      break;
    }
    case 3: {
      return this.kk;
      break;
    }
    case 4: {
      return this.eE;
      break;
    }
    case 5: {
      return this.Lh;
      break;
    }
    case 6: {
      return this.E0;
      break;
    }
    case 7: {
      return this.xr;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.D = (function() {
  return this.fB;
});
$p.ags = (function() {
  return this.kk;
});
$p.Hq = (function() {
  return ("c#" + this.n4);
});
$p.k4 = (function() {
  return this.n4;
});
function $isArrayOf_Lpresto_types$Credential(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jA)));
}
export { $isArrayOf_Lpresto_types$Credential as $isArrayOf_Lpresto_types$Credential };
var $d_Lpresto_types$Credential = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Credential, "presto.types$Credential", ({
  jA: 1,
  aH: 1,
  jC: 1,
  ed: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$Credential as $d_Lpresto_types$Credential };
//# sourceMappingURL=presto.types$-Credential.js.map
